module.exports = __webpack_public_path__ + "img/cover.3a6ae103.jpeg";